























































import { ICouponDetails } from "@/vuex/modules/coupon/interfaces";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class DetailsCouponAttached extends Vue {
  @Prop(Object) readonly couponDetails!: ICouponDetails;

  total = {
    qty: 0,
    value: 0,
  };

  @Watch("couponDetails.coupons_added")
  onCouponDetailsCouponsAdded(): void {
    this.couponDetails.coupons_added.forEach((value: any) => {
      this.total.qty += value.salesrule_qty;
      this.total.value +=
        parseFloat(value.discount_amount) * value.salesrule_qty;
    });
  }
}
